import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import RankingTable from "../Common/RankingTable";
import LastUpdate from "../Common/LastUpdate";
import { AddPageHeader } from "../Common/Utils";

const RankingInCountry = () => {
  const [countries, setRankingInCountry] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService
      .getRankingInCountry()
      .then((data) => setRankingInCountry(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("Ranking (in country)")}
      <Divider align="center">
        <h1>Ranking (in country)</h1>
      </Divider>
      <div className="privacy-terms">
        The{" "}
        <a
          href="https://doi.org/10.5281/zenodo.14034984"
          target="_blank"
          rel="noreferrer"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          methodology
        </a>{" "}
        explains how the Database and Rankings were developed. Notably, a single
        country can have multiple ISO codes for its territories (e.g., islands),
        so comparisons should account for this. Moreover, nine international
        organizations are considered for permanent missions.
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <LastUpdate />
        </div>
      </div>
      <RankingTable data={countries} searchEnabled longDescription inCountry />
    </div>
  );
};

export default RankingInCountry;
